import { render, staticRenderFns } from "./goods_search.vue?vue&type=template&id=556d1660&scoped=true"
import script from "./goods_search.vue?vue&type=script&lang=js"
export * from "./goods_search.vue?vue&type=script&lang=js"
import style0 from "./goods_search.vue?vue&type=style&index=0&id=556d1660&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d1660",
  null
  
)

export default component.exports